import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from 'environments/environment';
import { User } from '@common/models';
import { PagedData } from '@core/models/datables';
import { Observable } from 'rxjs';
import { AuthenticationType } from '../models/authentication-type';

@Injectable({ providedIn: 'root' })
export class AuthenticationTypeService {
  /**
   *
   * @param {HttpClient} _http
   */
  constructor(private _http: HttpClient) {}

  /**
   * Get all authentication types
   */
  getAll() {
    return this._http.get<AuthenticationType[]>(`${environment.commonApiUrl}/api/authentication-types`);
  }


  /**
   * Get key for external (office viewer) authentication
   * @returns 
   */
  getApiKey(){
    return this._http.get(`${environment.commonApiUrl}/api/key`, { responseType : 'text'}).toPromise();
  }

}
